<template>
  <div class="flex flex-col gap-8">
    <section id="dashboardInterests">
      <h3 class="font-display text-sm font-bold uppercase tracking-wider text-ink">
        {{ $t('components.dashboard_sidebar.interests') }}
      </h3>
      <p class="mt-1 text-base leading-snug text-muted">
        {{ $t('components.dashboard_sidebar.interests_hint') }}
      </p>

      <div v-if="user.interests.length" class="mt-3 flex flex-wrap gap-2">
        <button
          v-for="interest in user.interests"
          :key="interest.id"
          :disabled="isUpdatingInterests"
          type="button"
          class="cursor-pointer rounded-full border-none bg-ink px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-60"
          :title="$t('forms.remove')"
          @click="removeInterest(interest)"
        >
          {{ $t('categories.' + interest.id) }}
        </button>
        <button
          type="button"
          class="cursor-pointer rounded-full border border-solid border-outline bg-white px-4 py-2 text-sm font-semibold text-muted transition-colors hover:border-ink hover:text-ink"
          @click="toggleInterestsModal(true)"
        >
          + {{ $t('components.dashboard_sidebar.add_interests') }}
        </button>
      </div>

      <div v-else class="mt-3">
        <button
          type="button"
          class="cursor-pointer rounded-full border border-solid border-outline bg-white px-4 py-2 text-sm font-semibold text-ink transition-colors hover:border-ink"
          @click="toggleInterestsModal(true)"
        >
          + {{ $t('components.dashboard_sidebar.add_interests') }}
        </button>
      </div>
    </section>

    <section id="dashboardFollowing">
      <dashboard-sidebar-followings />
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DashboardSidebarFollowings from './DashboardSidebarFollowings'

export default {
  name: 'DashboardSidebar',
  components: {
    DashboardSidebarFollowings
  },
  data () {
    return {
      isUpdatingInterests: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'dashboardUser'
    })
  },
  methods: {
    ...mapActions({
      toggleInterestsModal: 'toggleDashboardInterestsModal',
      updateDashboardUserRequest: 'updateDashboardUserRequest'
    }),
    removeInterest (interest) {
      if (this.isUpdatingInterests) return
      this.isUpdatingInterests = true
      const payload = {
        interests: this.user.interests
          .filter(item => item.id !== interest.id)
          .map(item => item.id)
      }
      this.updateDashboardUserRequest(payload)
        .catch(error => {
          this.$displayRequestError(error, this.$t('errors.user_interests_could_not_updated'))
        })
        .finally(() => {
          this.isUpdatingInterests = false
        })
    }
  }
}
</script>
